module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liveblock"
    }
  }, [(_vm.shouldRenderTop) ? _c('top') : _vm._e(), _vm._v(" "), (_vm.shouldRenderSlider) ? _c('slider') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bad85b94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Liveblock.vue
// module id = 103
// module chunks = 1